import { Icons, Tag } from '@pankod/refine-antd'

import {
  PROGRAM_LOCAL_STATE,
  PROGRAM_LOCAL_STATES,
  TimespendEligibleStatus,
  TimespendPaymentStatus,
} from './types'

export const getNextProgramLocalState = (
  currentState: PROGRAM_LOCAL_STATE,
  states: PROGRAM_LOCAL_STATE[] = PROGRAM_LOCAL_STATES,
) => {
  const currentIndex = states.indexOf(currentState)
  if (currentIndex === -1) return states[0]
  const nextIndex = (currentIndex + 1) % states.length
  return states[nextIndex] || states[states.length - 1]
}

export const getPaymentStatusTag = (status?: TimespendPaymentStatus) => {
  const config: Record<
    TimespendPaymentStatus,
    { text: string; color: string; icon: React.ReactNode }
  > = {
    PAYMENT_STATUS_PAID: {
      color: 'success',
      text: 'Sudah Dibayar',
      icon: <Icons.CheckCircleOutlined />,
    },
    PAYMENT_STATUS_NOT_PAID: {
      color: 'warning',
      text: 'Belum Dibayar',
      icon: <Icons.ExclamationCircleOutlined />,
    },
  }
  const { color, icon, text } = config[status || 'PAYMENT_STATUS_NOT_PAID']
  return (
    <Tag color={color} icon={icon} className="uppercase flex items-center">
      {text}
    </Tag>
  )
}

export const getEligibilityTag = (status?: TimespendEligibleStatus) => {
  const config: Record<
    TimespendEligibleStatus,
    { text: string; color: string }
  > = {
    ELIGIBLE_STATUS_ELIGIBLE: {
      color: 'success',
      text: 'Sudah Terpenuhi',
    },
    ELIGIBLE_STATUS_NOT_ELIGIBLE: {
      color: 'warning',
      text: 'Belum Terpenuhi',
    },
  }
  const { color, text } = config[status || 'ELIGIBLE_STATUS_NOT_ELIGIBLE']
  return (
    <Tag color={color} className="uppercase">
      {text}
    </Tag>
  )
}

export const getEligibilityTagByDuration = (current: number, target: number) =>
  getEligibilityTag(
    current < target
      ? 'ELIGIBLE_STATUS_NOT_ELIGIBLE'
      : 'ELIGIBLE_STATUS_ELIGIBLE',
  )

export const separateThousand = (value: string | number = '') =>
  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
